import { useState } from "react";
import { submitForm } from "../../../api/submitForm";
import Honeypot from "../../../components/honeypot";
import { useFormTiming } from "../../../components/useFormTiming";
import { useTranslation } from "../../../i18n/useTranslation";

const Contact = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", entity: "", message: "" });
  const [hp, setHp] = useState("");
  const startedAt = useFormTiming();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    const result = await submitForm(
      "contact",
      form.entity,
      { name: form.name, email: form.email, message: form.message },
      { hp, startedAt }
    );
    if (result.ok) {
      setStatus("sent");
    } else {
      setStatus("error");
      setError(result.error);
    }
  };

  return (
    <div>
      <div className="band-hero section text-center">
        <div className="eyebrow">{t("contact.eyebrow")}</div>
        <h1>{t("contact.heading")}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("contact.intro")}</p>
        </div>
      </div>

      <div className="band-a section-tight">
        <div className="max-w-md mx-auto px-5">
          <div className="card-ledger text-left">
            {status === "sent" ? (
              <p className="mini">{t("contact.sentMessage")}</p>
            ) : (
              <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
                <Honeypot value={hp} onChange={(e) => setHp(e.target.value)} />
                <input className="field" placeholder={t("contact.namePlaceholder")} required value={form.name} onChange={update("name")} />
                <input type="email" className="field" placeholder={t("contact.emailPlaceholder")} required value={form.email} onChange={update("email")} />
                <select className="field" required value={form.entity} onChange={update("entity")}>
                  <option value="" disabled>{t("contact.entityPlaceholder")}</option>
                  <option value="global">{t("contact.entityGlobal")}</option>
                  <option value="bharat">{t("contact.entityBharat")}</option>
                  <option value="usa">{t("contact.entityUsa")}</option>
                  <option value="other">{t("contact.entityOther")}</option>
                </select>
                <textarea className="field" placeholder={t("contact.messagePlaceholder")} rows="4" required value={form.message} onChange={update("message")} />
                <button type="submit" className="btn-brass self-start" disabled={status === "sending"}>
                  {status === "sending" ? t("contact.sendingBtn") : t("contact.sendBtn")}
                </button>
                {status === "error" && <p className="mini" style={{ color: "#c0392b" }}>{error}</p>}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
